import { motion } from "framer-motion";
import { ShieldCheck, Clock, Lock, BadgeCheck, Search } from "lucide-react";
import AnimatedCounter from "@/components/ui/animated-counter";

const stats = [
  { value: "5000+", label: "Verified Providers" },
  { value: "500000+", label: "Annual Searches" },
  { value: "22", label: "Cities Live" },
  { value: "99+", label: "Uptime %" },
];

const trustBadges = [
  { icon: ShieldCheck, label: "Verified Healthcare Providers", iconColor: "text-emerald-600" },
  { icon: Clock, label: "24/7 Support & Helpline", iconColor: "text-blue-600" },
  { icon: Lock, label: "Secure & Encrypted Platform", iconColor: "text-violet-600" },
  { icon: BadgeCheck, label: "AI-Verified Listings", iconColor: "text-amber-600" },
  { icon: Search, label: "Real-Time Search Index", iconColor: "text-primary" },
];

const TrustStrip = () => {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-background to-secondary/40">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3">
            Trusted by <span className="text-gradient">thousands</span> across India
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Built for credibility — every provider is reviewed, verified and continuously audited.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-10">
          {stats.map((s) => (
            <div
              key={s.label}
              className="bg-card/80 backdrop-blur-xl border border-border/60 rounded-2xl p-5 sm:p-6 shadow-card text-center"
            >
              <AnimatedCounter
                value={s.value}
                label={s.label}
                valueClassName="text-gradient"
                labelClassName="text-muted-foreground uppercase tracking-wider text-[11px] font-semibold"
              />
            </div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-3"
        >
          {trustBadges.map((b) => (
            <span
              key={b.label}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-pill bg-card border border-border/60 text-xs sm:text-sm font-medium text-foreground/80 shadow-sm hover:shadow-md hover:border-primary/30 transition-all"
            >
              <b.icon className={`w-4 h-4 ${b.iconColor}`} />
              {b.label}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustStrip;
